import { PaginatedBidResponse } from '@bonhams1793/bonhams-typescript'

import { createAuthenticatedAxiosClient } from '@nx/axios-client'
import { BonhamsCookies } from '@nx/global-types'

export interface GetActiveBidsProps {
  baseURL: string
  cookies: BonhamsCookies
  biddableLotsOnly?: boolean
  lotId?: number
  cancelled?: boolean
  page?: number
  page_size?: number
}

export async function getUserBids({
  baseURL,
  cookies,
  ...params
}: GetActiveBidsProps) {
  const authenticatedAxiosClient = createAuthenticatedAxiosClient({
    accessTokenSSR: cookies.bonhams_access,
    refreshTokenSSR: cookies.bonhams_token,
    baseURL,
  })

  let url = '/api/bbe/v1/maxbids'
  const searchParams = new URLSearchParams(
    Object.entries(params)
      .filter(([, value]) => value !== undefined)
      .map(([key, value]) => {
        if (key === 'cancelled') {
          return [key, Number(value).toString()]
        }

        return [key, value.toString()]
      })
  )

  if (searchParams.toString()) {
    url = url.concat(`?${searchParams.toString()}`)
  }

  const response = await authenticatedAxiosClient.get<PaginatedBidResponse>(
    url,
    {
      baseURL,
    }
  )

  return response.data
}
